<template>
  <popover-right v-model="isShowImport" width="650px" :closed="cancel" :completeClose="cancel">
    <h1 class="popover-right-title">导入文章</h1>
    <el-form class="pover-right-con project-list" :model="info" :rules="rules" ref="resourceImportRef">
      <div class="header-con">
        <p class="label">温馨提示：导入文章请先获得原作者的授权</p>
      </div>
      <div class="form-list-info">
        <div class="base-col">
          <div class="item">
            <span class="label label-required">类型：</span>
            <el-form-item prop="sub_type" class="lebel-con label-con-1">
              <el-select v-model="info.sub_type" placeholder="请选择类型">
                <el-option :label="data" :value="key" :key="key" v-for="(data, key) in options.article_sub_type"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="item">
            <span class="label label-required">文章链接：</span>
            <el-form-item prop="url" class="lebel-con label-con-1">
              <el-input v-model="info.url" placeholder="请输入文章链接" style="max-width:500px;" clearable></el-input>
            </el-form-item>
          </div>
          <div class="item import-item">
            <span class="label"></span>
            <el-checkbox :label="true" v-model="info.agree">
              <span class="agree">请先阅读并同意<a href="http://www.haofang.com.cn/resource/wechatSassAgreement.html" target="black">《导入文章协议》</a></span>
            </el-checkbox>
          </div>
          <div class="item">
            <span class="label"></span>
            <div class="lebel-con">
              <div class="custom-btn">
                <el-button type="primary" @click="save">导入文章</el-button>
                <el-button type="info" @click="cancel">取消</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-form>
  </popover-right>
</template>
<script>
import PopoverRight from '@/components/popover/index';
import {importCompanySource} from '@/api/shop';
export default{
  name: 'ImportItem',
  components: {
    PopoverRight
  },
  data () {
    const validateUrl = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入文章链接'));
      } else if (!/^[a-zA-Z0-9!@#\$%^&\*\(\)_\-=\+|\\/\.;:"'\{\}\[\]?><,]{1,200}$/.test(value)) {
        callback(new Error('文章链接长度不超过200字符且不能包含中文'));
      } else {
        callback();
      }
    }
    return {
      isShowImport: false,
      info: {
        agree: false,
        url: '',
        sub_type: '1'
      },
      rules: {
        url: [
          {validator: validateUrl, trigger: 'blur'}
        ],
        sub_type: [
          {required: true, message: '请选择类型', trigger: 'change'}
        ]
      },
      options: {}
    }
  },
  async created() {
    this.options = await this.$store.dispatch('initConfig', ['article_sub_type']);
  },
  methods: {
    open () {
      this.isShowImport = true;
    },
    cancel () {
      this.info = {
        agree: false,
        url: '',
        sub_type: '1'
      }
      this.isShowImport = false;
      this.$nextTick(_ => {
        this.$refs?.resourceImportRef?.clearValidate();
      })
    },
    save () {
      this.$refs?.resourceImportRef?.validate(async valid => {
        if (!valid) return null;
        if (!this.info.agree) {
          this.$message.error('请先阅读并同意《导入文章协议》');
          return null;
        }
        try {
          await importCompanySource({
            url: this.info.url,
            sub_type: this.info.sub_type
          })
          this.$message.success('操作成功');
          this.cancel();
          this.$parent?.initList?.();
        } catch (error) {
          this.$message.error(error.msg || '操作失败，请重试');
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.header-con{
  padding-top: 10px;
  .iconfont{
    font-size: 18px;
    color: #FF943C;
    display: inline-block;
    vertical-align: middle;
  }
  .label{
    font-size: 14px;
    color: #999999;
    display: inline-block;
    vertical-align: middle;
    margin-left: 5px;
  }
}
.import-item{
  padding-top: 15px !important;
}
.agree{
  color: #999;
  font-size: 13px;
  a{
    color: #25a0ff;
    text-decoration: none !important;
  }
}
</style>